import { Injectable } from '@angular/core';
import { APP_CONST } from '../../app.const';
import { RequestService } from '../../libraries/http/request.service';

@Injectable()
export class BatteryRentRestService {
  constructor(private _request: RequestService) {}
  baseURL = `${APP_CONST.API_MASTER}`;
  request = this._request.new(this.baseURL);

  findAll(queryParams: any = {}) {
    return this.request.get<any>(`/admin/battery-rent`, { params: queryParams });
  }

  create(payload: any) {
    return this.request.post<any>(`/admin/battery-rent/create`, payload);
  }

  createCustomer(payload: any) {
    return this.request.post<any>(`/admin/battery-rent/create-customer`, payload);
  }

  getCustomer(queryParams: any = {}) {
    return this.request.get<any>(`/admin/battery-rent/customer`, { params: queryParams });
  }

  stopRent(payload: any) {
    return this.request.patch<any>(`/admin/battery-rent/unpair-battery`, payload);
  }

  replace(payload: any) {
    return this.request.patch<any>(`/admin/battery-rent/replace-battery`, payload);
  }

  getMembershipHistory(batteryCode: any = {}) {
    return this.request.get<any>(`/admin/battery-rent/membership-battery?batteryCode=${batteryCode}`);
  }

  redeem(payload: any) {
    return this.request.patch<any>(`/admin/battery-rent/redeem`, payload);
  }

  getRedeemPrice(chassisNumber: string, totalMonths: number) {
    return this.request.post<any>(`/admin/battery-rent/redeem-price?chassisNumber=${chassisNumber}&totalMonths=${totalMonths}`)
  }
  
  update(payload: any, id: string) {
    return this.request.patch<any>(`/admin/battery-rent/update/${id}`, payload);
  }

  getProvinces() {
    return this.request.get<any>(`/admin/battery-rent/province`);
  }

  getCities(province_id) {
    return this.request.get<any>(`/admin/battery-rent/city?province_id=${province_id}`);
  }

  getMotorcycleTypes() {
    return this.request.get<any>(`/admin/battery-rent/motorcycle-type`);
  }

  getPresignedUrl(payload) {
    const req = this._request.new(`${APP_CONST.API_MASTER}`);
    return req.post<any>('/admin/spk/pre-signed-url', payload)
  }
}
